const Collaborators = () => import('@/domain/collaborators/index.vue')

export default [
    {
        path: 'collaborators',
        name: 'event.collaborators',
        component: Collaborators,
        meta: {
            label: 'Collaborators',
            title: 'Collaborators',
            scopeType: 'pica-service',
            permission: 'collaborator.list'
        }
    }
]